import { FlyOut, FlyOutList, FlyOutToggle } from '@/components';

import { R } from '@/caregiverSpace/resources/Texts.resx';

export const ActionButtonsFlyOutMenu = ({
    children,
}: {
    children: React.ReactNode;
}) => {
    return (
        <FlyOut>
            <FlyOutToggle helpText={R.More} />
            <FlyOutList portalClassName="caregiver-space">
                {children}
            </FlyOutList>
        </FlyOut>
    );
};
